import React  from 'react';
import xiaoshouzhengce from '../assets/img/xiaoshouzhengce.png';
const Enclosure634 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
        <img src={xiaoshouzhengce} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
                        

            <br/><br/>
        </div>
    </div>


export default Enclosure634;